<template>
  <div class="logo-restricted-content" id="identidade-visual-logo-versao-restrita" data-search-anchor>
    <div class="title-restricted-wrapper">
      <h1 class="logo-restricted-title-span">{{ logoRestrictedVersionTitleSpan }}</h1>
      <h1 class="logo-restricted-title">{{ logoRestrictedVersionTitle }}</h1>
    </div>
    <div class="description-restricted-wrapper">
      <p class="logo-restricted-description-main">{{ logoRestrictedVersionDescription }}</p>
    </div>
    <div class="description-restricted-wrapper">
      <div class="icon-wrapper">
        <IconCheck />
        <p class="logo-restricted-description">{{ logoRestrictedVersionDescription1 }}</p>
      </div>

      <div class="icon-wrapper">
        <IconCheck />
        <p class="logo-restricted-description">{{ logoRestrictedVersionDescription2 }}</p>
      </div>
    </div>
    <div
      class="logo-restricted-card-item"
      :style="{ backgroundImage: `url(${logoRestrictedVersionImageSrc})` }"
    ></div>
  </div>
</template>

<script lang="ts">
import IconCheck from '@/assets/icons/IconCheck.vue'
import { PageStoreContract } from '@/data/store/page.store.contract'
import VisualIdentityPageMixin from '@/mixins/visual-identity-page-mixin'
import { VisualIdentityPageStore } from '@/store/visual-identity-page/visual-identity-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({ components: { IconCheck } })
export default class LogoRestrictedVersionSection extends Mixins(VisualIdentityPageMixin) {
  visualIdentityPageStore: PageStoreContract = getModule(VisualIdentityPageStore, this.$store)

  get logoRestrictedVersionTitleSpan(): string {
    return this.getElementTitle(13, 0)
  }

  get logoRestrictedVersionTitle(): string {
    return this.getElementText(13, 0)
  }

  get logoRestrictedVersionDescription(): string {
    return this.getElementText(13, 1)
  }

  get logoRestrictedVersionDescription1(): string {
    return this.getElementText(13, 2)
  }

  get logoRestrictedVersionDescription2(): string {
    return this.getElementText(13, 3)
  }

  get logoRestrictedVersionImageSrc(): string {
    return this.getElementMedia(13, 4)
  }

  async getVisualIdentityPage(): Promise<void> {
    await this.visualIdentityPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.visualIdentityPageStore.isLoading) {
      await this.getVisualIdentityPage()
    }
  }
}
</script>

<style lang="scss">
.logo-restricted-content {
  width: 100%;
  display: grid;
  max-width: 1032px;
}

.title-restricted-wrapper {
  display: flex;
  align-items: center;
  height: 6vh;
  padding-top: 6.25rem;
  padding-bottom: 2rem;
}

.logo-restricted-title-span {  
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  margin-right: 5px;
  color: #b3b3b3;
}

.logo-restricted-title { 
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  color: #000000;
}

.description-restricted-wrapper {  
  position: relative;  

  display: grid;
  grid-template-columns: 51% 49%;  
}

.logo-restricted-description-main {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;

  width: 430px;
  margin: 0;
}

.logo-restricted-description {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;

  padding-left: 7px;
  width: 378px;  
}

.title-image {  
  font-size: 20px;
  font-weight: 600;
  text-align: left;

  padding-left: 3rem;
  width: 187px;
}

.logo-restricted-card-item {
  position: relative;
  bottom: 0;
  width: 100%;
  max-width: 1032px;
  height: 705px;  
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain
}

.logo-restricted-card-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3rem;

  margin: 1rem 0rem 5rem 0rem;
}
</style>
